import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';
import { ROUTES } from '../config/routes';
import { api } from '../services/api';

export const TrialExpiredModal: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [dismissed, setDismissed] = React.useState(false);

  React.useEffect(() => {
    api.post('/subscription/conversion-event', { event_type: 'banner_shown', source: 'trial_modal' }).catch(() => {});
  }, []);

  if (dismissed) return null;
  if (!user || user.plan !== 'trial') return null;
  if (!user.trial_ends_at) return null;
  if (new Date(user.trial_ends_at) > new Date()) return null;

  const handleLogout = () => {
    useAuthStore.getState().clearAuth();
    navigate(ROUTES.LOGIN);
  };

  return (
    <div
      data-testid="trial-expired-modal"
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
    >
      <div style={{ background: '#fff', borderRadius: '16px', width: '90%', maxWidth: '480px', padding: '36px 32px', boxShadow: '0 20px 50px rgba(15,23,42,0.25)', textAlign: 'center' }}>
        {/* Zapアイコン (light teal circle) */}
        <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#F0FDFA', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
          <Zap size={26} style={{ color: '#0a7a72' }} />
        </div>

        <div style={{ fontSize: '18px', fontWeight: 700, color: '#0F172A', marginBottom: '10px' }}>
          無料トライアルが終了しました
        </div>
        <div style={{ fontSize: '14px', color: '#64748B', lineHeight: 1.8, marginBottom: '28px' }}>
          14日間の無料トライアル期間が終了しました。プランに加入すると、チャットボットがすぐに再開し、これまでの学習データもそのままご利用いただけます。
        </div>

        <button
          data-testid="trial-expired-upgrade-link"
          onClick={() => {
            api.post('/subscription/conversion-event', { event_type: 'cta_click', source: 'trial_modal' }).catch(() => {});
            setDismissed(true);
            navigate(ROUTES.SUBSCRIPTION);
          }}
          style={{ width: '100%', background: '#0a7a72', color: '#fff', border: 'none', borderRadius: '8px', padding: '14px 20px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', marginBottom: '16px' }}
        >
          プランを見て再開する
        </button>

        <button
          onClick={handleLogout}
          style={{ background: 'none', border: 'none', fontSize: '14px', color: '#64748B', cursor: 'pointer', padding: '4px 8px' }}
        >
          ログアウト
        </button>
      </div>
    </div>
  );
};
